import { gql } from '@/__generated__';

const SEND_SMA_REPORTS_EXCEL_BY_EMAIL = gql(`#graphql
  mutation SendSmaReportsExcelByEmail($input: SendSmaReportsExcelByEmailInput!) {
    sendSmaReportsExcelByEmail(input: $input)
  }
`);

export default SEND_SMA_REPORTS_EXCEL_BY_EMAIL;
